import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';
import forEach from 'lodash.foreach';
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

const AchievementsTypes = VuexTypes.achievements;

export default {
  data () {
    return {
      spinners: {
        contentIsLoading: true,
        submitting: false
      },
      achievements: [],
      confirmAchievementId: null,
      confirmModalError: null,
      confirmModalAchievementCode: null,
    }
  },
  computed: {
    ...mapGetters('Achievements', [
      'achievementsProgress',
      'achievementsClaim'
    ]),
  },
  filters: {
    rgbaBackground(value) {
      return 'background: ' + hexToRgba(value.toLowerCase(), 30) + ';';
    }
  },
  methods: {
    ...mapActions('Achievements', [
      AchievementsTypes.ACHIEVEMENTS_PROGRESS,
      AchievementsTypes.ACHIEVEMENTS_CLAIM,
    ]),
    getData() {
      this.spinners.contentIsLoading = true;
      this.ACHIEVEMENTS_PROGRESS();
    },
    fillData(limit = null) {
      const result = [];

      forEach(this.achievementsProgress.data.data, (item) => {
        if (limit === null || result.length < limit) {
          result.push({
            id: item.id,
            imagePath: item.image ? item.image.path : null,
            texts: item.texts,
            progress: parseInt(item.progress),
            goal: item.goal,
            isCharity: item.is_charity,
            isHighlighted: item.is_highlighted,
            colorHex: item.color_hex
          });
        }
      });

      this.achievements = result;
    },
    getProgressPercent(progress, goal) {
      const percent = (progress / goal) * 100;
      return percent <= 100 ? percent : 100;
    },
    openConfirmModal(achievement, event) {
      event.preventDefault();

      if (!this.hasSufficientCredits(achievement)) {
        this.alertError();
        return;
      }

      this.confirmAchievementId = achievement.id;
      this.$refs['modal-confirm'].show();
    },
    closeConfirmModal() {
      this.onConfirmModalClose();
      this.$refs['modal-confirm'].hide();
    },
    onConfirmModalClose() {
      this.confirmAchievementId = null;
      this.confirmModalError = null;
      this.confirmModalAchievementCode = null;
    },
    submitConfirmModal() {
      this.spinners.submitting = true;
      this.ACHIEVEMENTS_CLAIM(this.confirmAchievementId);
    },
    hasSufficientCredits(achievement) {
      return achievement.progress >= achievement.goal;
    }
  }
}
